<svelte:head>
  <title>Edit | {data?.title || 'Need'} | A Good Thing</title>
</svelte:head>

<h2 class="title">Edit Need</h2>

{#if data}
  <NeedsEditor {data} isValid={true} />
{/if}

<div class="field">
  <div class="control">
    <button
      class="button is-primary"
      class:is-loading={isLoadingFinish}
      on:click={() => update(true)}>Finish and review</button>
    &nbsp;
    <button
      class="button"
      class:is-loading={isLoadingSave}
      on:click={() => update(false)}>Save for later</button>
  </div>
</div>

{#if errorMessage}
  <div class="notification is-danger is-light">{errorMessage}</div>
{/if}

<script lang="ts">
  import _ from 'lodash';
  import { goto, params } from '@sveltech/routify';

  import NeedsEditor from '../../_components/NeedsEditor.svelte';

  let id: string = $params['id'];

  let data: Need_v1;

  let errorMessage: string;
  let isLoadingFinish = false;
  let isLoadingSave = false;

  let firebase = window.firebase;

  get();

  async function get() {
    data = await firebase
      .firestore()
      .collection('needs_v1')
      .doc(id)
      .get()
      .then((doc) => doc.data() as Need_v1);
  }

  async function update(finish: boolean) {
    if (finish) {
      isLoadingFinish = true;
    } else {
      isLoadingSave = true;
    }

    await firebase
      .firestore()
      .collection('needs_v1')
      .doc(id)
      .set(data)
      .catch((err) => {
        errorMessage = err;
      })
      .finally(() => {
        isLoadingSave = false;
        isLoadingFinish = false;
      });

    if (finish) {
      $goto('../../../need/' + id);
    } else {
      $goto('../../../needs/');
    }
  }
</script>
